// getLiveStreamPinnedMessages.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import { LIVESTREAM_MAX_PIN_LENGTH } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

const emptyList = [];

/**
 * Select live stream pinned messages by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {array} The latest certain amount pinned messages.
 */
const getLiveStreamPinnedMessages = createCachedSelector(
  (state, streamId) => getLiveStreamData(state, [streamId], 'pinned'),
  state => getRemoteConfigData(state, LIVESTREAM_MAX_PIN_LENGTH),
  (pinnedMessages = emptyList, maximumPinnedAmount = 1) => {
    const result = pinnedMessages.slice(maximumPinnedAmount * -1);
    return result;
  }
)((state, streamId) => streamId);

export default getLiveStreamPinnedMessages;
